export default {
  title: 'Definições',
  fields: {
    discount_type: {
      label: 'Tipo de desconto',
    },
  },
  buttons: {
    save: 'Guardar',
    cancel: 'Cancelar',
  },
  toasts: {
    update_successful: 'Atualizado com sucesso',
    updated_failed: 'Falha na atualização',
  },
};
